module.exports = __webpack_public_path__ + "img/handshake-angle.f9e7bb67.svg";